import invoiceStatus from '@/languages/ko-kr/invoice-status'
import bankCodes from '@/languages/ko-kr/bank-codes'

export default {
  'keep-kr': '@:terms.keep-kr',
  // TODO: modify transfer: 송금 하단 transfer['something']은 다르게 변경
  'transfertance': '@:terms.transfer',
  'tax-invoice': '@:terms.tax@:terms.tax-free-invoice',
  'tax-free-invoice': '@:terms.tax-free-invoice',
  'invoice': '@:terms.invoice',
  'invoices-title': '@:terms.purchase-invoice',
  'issue': '@:terms.issue',
  'issued-invoices-title': '@:terms.invoice @:terms.issue',
  'KRW': '@:terms.currency',
  'client': '@:terms.client',
  'cancel': '@:terms.cancel',
  'entire': '@:terms.entire',
  'exemption': '@:terms.exemption',
  'register': '@:terms.register',
  'tax-free': '@:terms.tax-free',
  'info': '@:terms.info',
  'delete': '@:terms.delete',
  'failed': '@:terms.failed',
  'status': {
    ...invoiceStatus,
  },
  'account': '@:terms.account',
  'need-transfer': '@:terms.transfer @:terms.need',
  'completed-transfer': '@:terms.transfer @:terms.complete',
  'message': {
    'empty-completed': ['송금 완료된 내역이', '없습니다.'],
    'processing-cert-message': '@:terms.certificate를 @:terms.register중입니다. @:terms.register이' +
      '완료되면 카톡으로 알려드립니다.',
    'empty-invoice': '@:pages.invoices.invoice가 존재하지 않습니다.',
    'empty-invoices': ['세금계산서가 조회되면,', '카톡으로 알람을 보내드립니다.'],
    'empty': ['송금 내역이 없습니다.'],
    'none-cert': ['공동인증서가', '등록되지 않았습니다.'],
    'processing-cert': ['공동인증서를 등록 중입니다.'],
    'empty-search-invoices': ['검색된 매입 세금 계산서가', '없습니다.'],
  },
  'footer': {
    'transfer-register': '@:terms.transfer하기',
    'plz-select': '@:terms.transfer할 계산서를 선택해주세요.',
    'register-cert': '@:terms.certificate 등록하기',
  },
  'transfer': {
    'select-bank': ['@:terms.client 계좌의', '@:terms.bank을 선택해주세요.'],
    'client-info': ['@:terms.client에 @:terms.transfer할, 정보를 입력해주세요.'],
    'confirm': ['같은 @:terms.client명의', '@:terms:tax 계산서가', '발견 되었습니다.', '위 계좌를 동일하게 적용할까요?'],
    'plz-password': ['이용자 @:terms.password를, 입력해주세요.'],
    'password': {
      'account': '계좌 @:terms.password',
      'otp': 'OTP @:terms.password',
    },
    'success': {
      'amount': '@:terms.transfer액',
      'fee': '@:terms.transfer @:terms.fee',
    },
  },
  'confirm': {
    'inspect-bank': {
      'title': '@:terms.bank 점검시간입니다.',
      'description': '12:00 ~ 12:30 까지 점검시간입니다. 나중에 다시 시도해주세요.'
    },
    'need-bank-cert': {
      'title': '송금을 하려면 은행에 연동된 공동인증서가 필요합니다.',
    },
    'confirmed-expired': {
      'title': '@:terms.certificate가 @:terms.expired되었습니다.',
      'description': '새 @:terms.certificate를 @:terms.register 하셔야 @:terms.transfer하실 수 있습니다. | ' +
        '새 @:terms.certificate를 @:terms.register 하셔야 @:terms.purchase-invoice가 조회됩니다.',
    },
  },
  'dialog': {
    'change-status': {
      'title': '상태 변경',
      'excluded': '잘못 발행 된 계산서 입니다.',
      'completed': '이미 송금한 계산서 입니다.',
      'possible': '송금이 필요한 계산서 입니다.',
    },
    'btn': {
      'cert-register': '공동인증서 등록하기',
      're-register': '@:terms.register하기',
      'confirm': '확인',
      'cancel': '취소',
      'close': '닫기',
      'no': '아니오',
      'adjust': '적용',
      'register': '@:terms.register하기',
    },
  },
  'error': {
    'need-confirm': '@:terms.purchase-invoice 확인 필요 목록을 불러오는데 실패하였습니다.',
    'completed-confirm': '@:terms.purchase-invoice 확인 완료 목록을 불러오는데 실패하였습니다.',
    'get-invoice': '@:pages.invoices.invoice 정보를 불러오는데 실패하였습니다.',
    'get-clients': '@:terms.client 정보를 불러오는데 실패하였습니다.',
    'get-client-accounts': '@:terms.client 계좌정보를 불러오는데 실패하였습니다.',
    'update-invoice-status': '@:pages.invoices.invoice @:terms.status를 ' +
      '@:terms.change하는데 실패하였습니다.',
  },
  'title-invalid': '@:terms.transfer 불가 계산서',
  'cancel-select': '선택 취소',
  'bank': '@:terms.bank',
  'bank-account': '@:terms.account번호',
  'bank-codes': {
    ...bankCodes,
  },
  'go-main': '홈으로',
  'client-bank-account': '@:terms.client @:terms.account',
  'invoice-info': '@:pages.invoices.invoice @:terms.info',
  'client-info': '@:terms.client @:terms.info',
  'transaction-info': '@:terms.transaction @:terms.info',
  'invoice-detail': {
    'amount': '합계금액',
    'clientName': '상호명',
    'supRepNm': '대표자명',
    'client-bank-account': '@:terms.client @:terms.account',
    'supAddress': '사업장주소',
    'supBizNo': '@:terms.business-operator@:terms.registration-number',
    'supEmail': '@:terms.email',
    'itemNm': '품목',
    'issueNo': '승인번호',
    'makeDt': '작성일자',
    'issueDt': '발급일자',
    'sendDt': '전송일자',
    'taxClsf': '상세분류',
    'supAmt': '공급가액',
    'totAmt': '합계금액',
    'taxAmt': '세액',
    'paidAt': '@:terms.transfer 일시',
    'bizBankAccount': '@:terms.banks.bank-account',
    'transferFee': '@:terms.fee'
  },
  'order': {
    'title': '@:terms.order',
    'modifiedAt': '최근 변경순',
    'newest': '최근 조회순',
    'issue': '최근 발행순',
    'lowAmount': '낮은 금액순',
    'highAmount': '높은 금액순',
  },
}
